import type {
  ConditionFieldDescription,
  ConditionsConfig_ConditionConfig,
} from "@smartsuite/automation-engine-api";
import { Icon, MenuGroupContent, MenuOption } from "@smartsuite/react-ui/lib";
import { StyledIcon } from "../../../../../Forms/InputForm/FieldEditor/FieldEditorRow/containers/TriggerOptions/style";
import { useEffect, useState } from "react";
import type { ActionCandidate } from "../../../../../../../types/candidate";
import { SolutionColorVariables } from "@smartsuite/types";

const NotSupportedConditionsFields = ["field-comments_count"];

interface ConditionsFieldGroup extends ConditionFieldDescription {
  nestedInputs: ConditionFieldDescription[];
  label: string;
  groupFieldId?: string;
}

export const ConditionOptions: React.FC<{
  condition: ConditionsConfig_ConditionConfig;
  onChange: (condition: ConditionsConfig_ConditionConfig) => void;
  conditionFields: ConditionFieldDescription[];
  action?: ActionCandidate;
  goSubMenu?: (options: ConditionFieldDescription[], label: string) => void;
}> = ({ condition, onChange, conditionFields, action, goSubMenu }) => {
  const [search, setSearch] = useState<string>("");
  const [groupedOptions, setGroupedOptions] = useState<ConditionsFieldGroup[]>(
    [],
  );

  useEffect(() => {
    const newGroupedOptions: ConditionsFieldGroup[] = [];
    conditionFields.forEach((input) => {
      if (input.groupFieldId === undefined) {
        newGroupedOptions.push({
          ...input,
          nestedInputs: [],
          label: input.label,
        });
        return;
      }
      const group = newGroupedOptions.find(
        (item) => item.groupFieldId === input.groupFieldId,
      );
      if (group === undefined) {
        newGroupedOptions.push({
          ...input,
          nestedInputs: [],
          label: input.label,
          groupFieldId: input.groupFieldId,
        });
      } else {
        group.nestedInputs.push(input);
      }
    });

    // remove not supported fields
    const supportedOption = newGroupedOptions.filter(
      (newGroupedOption) =>
        !NotSupportedConditionsFields.includes(
          newGroupedOption.conditionFieldId,
        ),
    );
    setGroupedOptions(supportedOption);
  }, [conditionFields]);

  const onOptionClick = (conditionFieldGroup: ConditionsFieldGroup): void => {
    if (conditionFieldGroup.nestedInputs?.length) {
      if (goSubMenu) {
        const nestedInputs = conditionFieldGroup.nestedInputs;
        goSubMenu(
          [...nestedInputs, conditionFieldGroup],
          conditionFieldGroup.label,
        );
      }
    } else {
      onChange({
        conditionFieldId: String(conditionFieldGroup.conditionFieldId),
      });
    }
  };

  return (
    <MenuGroupContent onSearchChange={(text) => setSearch(text)}>
      {groupedOptions
        .filter((option) =>
          search.length > 0
            ? option.label
                .toLocaleLowerCase()
                .includes(search.toLocaleLowerCase())
            : !(
                action !== undefined &&
                (option.conditionFieldId.includes(".by") ||
                  option.conditionFieldId.includes(".phone"))
              ),
        )
        .sort((a, b) => a.label.localeCompare(b.label))
        .map((field) => (
          <MenuOption
            key={field.conditionFieldId}
            submenuArrow={field.nestedInputs.length > 0 ? "right" : undefined}
            active={
              field.conditionFieldId.split(".")[0] ===
              condition.conditionFieldId.split(".")[0]
            }
            onClick={() => {
              onOptionClick(field);
            }}
          >
            <>
              <StyledIcon>
                <Icon
                  name={field.icon}
                  size="S"
                  color={SolutionColorVariables.sc1}
                />
              </StyledIcon>
              {field.label}
            </>
          </MenuOption>
        ))}
    </MenuGroupContent>
  );
};
